<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y8oUgC/tc-custom/9781847675026.jpg?1734559056970" alt="This image is the cover for the book Unlikely Stories, Mostly, Canongate Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unlikely Stories, Mostly, Canongate Classics
      </h1>
      <p class="bookDescription body article font2">
        <b>In this volume of stories and illustrations, the author of <i>Poor Things</i> “perfected the blend of visual and verbal elements [that] characterized his work” (<i>Financial Times</i>).</b><br/>  <br/> In “The Crank that Made the Revolution,” an enterprising inventor presents the world with his contribution to the Industrial Revolution: an “improved duck.” When a man splits in two, it isn’t long before his two selves come to blows in “The Spread of Ian Nicol.” And a young boy witnesses a shooting star land in his back garden in “The Star.” In these and other short stories of the strange and fascinating, Alasdair Gray reaffirms his reputation as one of Scotland’s most original and important contemporary writers.<br/>  <br/> In <i>Unlikely Stories, Mostly</i>, Alasdair Gray combines his surreal and darkly funny stories with original artwork to create a truly unique reading experience. This edition includes a postscript by the author and Douglas Gifford.<br/>  <br/><b>“The book is a wonder of ingenuity, a varied and rich collection in which Gray's abilities as a visual artist and illustrator are placed not only beside but within the products of his fertile imagination as a writer.” —<i>The Washington Post</i></b><br/>  <br/><b>“Not since William Blake has a British artist wed pictorial and literary talent to such powerful effect.” —<i>Financial Times</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alasdair Gray
      </h2>
      
      <p class="authorDescription body article">Born in 1934,&#160;<B>Alasdair Gray</B>&#160;graduated in design and mural painting from the Glasgow School of Art. Since 1981, when&#160;<I>Lanark </I>was published by Canongate, he authored, designed and illustrated seven novels, several books of short stories, a collection of his stage, radio and TV plays and a book of his visual art,&#160;<I>A Life in Pictures.&#160;</I>In November 2019, he received a Lifetime Achievement award from the Saltire Society.<I>&#160;</I>He died in December 2019, aged eighty-five.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canongate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f451f7f